import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
// src/utils.ts
function shouldThrowError(throwError, params) {
  if (typeof throwError === "function") {
    return throwError.apply(void 0, _toConsumableArray(params));
  }
  return !!throwError;
}
function noop() {}
export { noop, shouldThrowError };